<template>
  <div id="projects" class="container-fluid">
    <div class="padding-div skg-wording text-center">
      <h1>We take pride in the projects we've done</h1>
      <h5 class="p-3">
        We understand that each project represents not just a building, but the
        hopes and dreams of our clients.
      </h5>
    </div>
    <div class="row">
      <div class="col-12 col-lg-8 zero-padding">
        <img
          src="../assets/owyhee_hills_house.jpg"
          class="img-fluid-projects3"
          alt="Big house we built in the Owyhee Mountains"
        />
      </div>
      <div class="col-12 col-lg-4 zero-padding">
        <img
          src="../assets/midway_house.jpg"
          class="img-fluid-projects"
          alt="Midway through a current project house"
        />
        <img
          src="../assets/ag_building.jpg"
          class="img-fluid-projects"
          alt="Ag building we built in Adrian"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6 zero-padding">
        <img
          src="../assets/blue_house.jpg"
          class="img-fluid-projects"
          alt="Big blue house we built"
        />
      </div>
      <div class="col-12 col-lg-6 zero-padding">
        <img
          src="../assets/farm_house.jpg"
          class="img-fluid-projects"
          alt="Our farm house"
        />
      </div>
    </div>
    <div class="div-hr-padding">
      <hr class="div-hr" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.zero-padding {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.img-fluid-projects {
  min-width: 100%;
  max-width: 100%;
  height: auto;
}
.img-fluid-projects3 {
  min-height: 100%;
  max-height: 100%;
  max-width: 100%;
}
</style>